/**
 * SWP Product Landing Page JavaScript
 * Handles: FAQ accordion, image gallery, sticky CTA, quantity selector
 */

(function() {
  'use strict';

  /**
   * FAQ Accordion
   */
  function initFaqAccordion() {
    const faqItems = document.querySelectorAll('.swp-pl-faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.swp-pl-faq-item__question');

      if (question) {
        question.addEventListener('click', () => {
          const isActive = item.classList.contains('active');

          // Close all other items
          faqItems.forEach(otherItem => {
            otherItem.classList.remove('active');
          });

          // Toggle current item
          if (!isActive) {
            item.classList.add('active');
          }
        });
      }
    });
  }

  /**
   * Image Gallery
   */
  function initImageGallery() {
    const mainImage = document.getElementById('swp-pl-main-image');
    const thumbnails = document.querySelectorAll('.swp-pl-hero__thumbnail');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        // Update main image
        const fullSrc = thumbnail.getAttribute('data-full') || thumbnail.src;
        mainImage.src = fullSrc;

        // Update active state
        thumbnails.forEach(t => t.classList.remove('active'));
        thumbnail.classList.add('active');
      });
    });
  }

  /**
   * Sticky CTA (Mobile)
   */
  function initStickyCta() {
    const stickyCta = document.querySelector('.swp-pl-sticky-cta');
    const heroSection = document.querySelector('.swp-pl-hero');

    if (!stickyCta) return;

    function checkScroll() {
      const scrollThreshold = heroSection ? heroSection.offsetHeight : 500;

      if (window.innerWidth <= 750) {
        if (window.scrollY > scrollThreshold) {
          stickyCta.classList.add('visible');
          document.body.classList.add('swp-pl-has-sticky-cta');
        } else {
          stickyCta.classList.remove('visible');
          document.body.classList.remove('swp-pl-has-sticky-cta');
        }
      } else {
        stickyCta.classList.remove('visible');
        document.body.classList.remove('swp-pl-has-sticky-cta');
      }
    }

    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    checkScroll();
  }

  /**
   * Quantity Selector
   */
  function initQuantitySelector() {
    const quantitySelectors = document.querySelectorAll('.swp-pl-quantity__selector');

    quantitySelectors.forEach(selector => {
      const decreaseBtn = selector.querySelector('[data-action="decrease"]');
      const increaseBtn = selector.querySelector('[data-action="increase"]');
      const input = selector.querySelector('.swp-pl-quantity__input');

      if (!decreaseBtn || !increaseBtn || !input) return;

      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 99;

      decreaseBtn.addEventListener('click', () => {
        let value = parseInt(input.value) || min;
        if (value > min) {
          input.value = value - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      increaseBtn.addEventListener('click', () => {
        let value = parseInt(input.value) || min;
        if (value < max) {
          input.value = value + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      input.addEventListener('change', () => {
        let value = parseInt(input.value) || min;
        value = Math.max(min, Math.min(max, value));
        input.value = value;
      });
    });
  }

  /**
   * Variant Selector
   */
  function initVariantSelector() {
    const variantOptions = document.querySelectorAll('.swp-pl-variants__option');

    variantOptions.forEach(option => {
      option.addEventListener('click', () => {
        const group = option.closest('.swp-pl-variants__options');
        if (!group) return;

        // Remove selected from siblings
        group.querySelectorAll('.swp-pl-variants__option').forEach(opt => {
          opt.classList.remove('selected');
        });

        // Add selected to clicked option
        option.classList.add('selected');

        // Update hidden input if exists
        const variantId = option.getAttribute('data-variant-id');
        const hiddenInput = document.querySelector('input[name="id"]');
        if (variantId && hiddenInput) {
          hiddenInput.value = variantId;
        }

        // Trigger custom event for price updates
        document.dispatchEvent(new CustomEvent('swp-pl:variant-change', {
          detail: { variantId: variantId }
        }));
      });
    });
  }

  /**
   * Smooth Scroll for Anchor Links
   */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /**
   * Scroll to Top (for CTA buttons)
   */
  function initScrollToTop() {
    document.querySelectorAll('[data-scroll-top]').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    });
  }

  /**
   * Initialize all components
   */
  function init() {
    initFaqAccordion();
    initImageGallery();
    initStickyCta();
    initQuantitySelector();
    initVariantSelector();
    initSmoothScroll();
    initScrollToTop();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify section is loaded/updated
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

})();
